<template>
    <div>
        <div class="form-group" v-if="prefijo==enumeraciones.etiquetasDeHTML.Select">
            <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
                <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una sede de Archivo</option>
                <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los estatus de los documentos</option>
                <option v-for="tipoSedeArchivo in SedesArchivo" :value="tipoSedeArchivo.SedeArchivoId">{{tipoSedeArchivo.Nombre}}</option>
            </select>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import axios from 'axios';
import api from '@/../static/js/api';
import comun from '@/../static/js/comun';

export default {
    data(){
        return {
            enumeraciones,
            comun,
            SedesArchivo :[],
            idDelModelo: null
        }
    },
    props: {
        prefijo: Number,
        tipo: {
                Id: Number,
                Nombre: String 
            },
        idDelInput: String,
        valorDefinido: Number,
        parametros: Object
    },
    mounted() {
        if(this.valorDefinido == undefined || this.valorDefinido == null)
            {this.idDelModelo = this.tipo.Id;}
        else
            {this.idDelModelo = this.valorDefinido;}

        const parametros = {
            llave: this.idDelInput,
            valor: this.idDelModelo
        }
      
        this.$store.dispatch("A_ArchivoJudicial_Catalogo_Establecer012SedesArchivo", parametros);
    },
    methods: {
        cargaCatalogoSedesArchivo(){
            if(this.parametros == null || this.parametros == undefined)
                this.parametros = {}
            axios.post(api.conexion + api.ArchivoJudicial.TipoSedesArchivo, this.parametros)
            .then(respuesta=> {
                if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.SedesArchivo = respuesta.data.TiposSedesArchivo;
              if(this.parametros.filtros !=undefined && this.parametros.filtros != null) {
                  this.SedesArchivo = respuesta.data.SedesArchivo.filter(cond=>this.parametros.filtros.some(tipo=>tipo.TiposEstatusInventario.TipoEstatusInventarioDocumentoId));
              }    
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })   
        },
        cambiarDatos(evento) {
            this.idDelModelo = evento.target.value;
            const parametros = {
                llave: this.idDelInput,
                valor: evento.target.value
                }
            this.$store.dispatch("A_ArchivoJudicial_Catalogo_Establecer012SedesArchivo", parametros);
            this.$emit("valorParaElPadre", evento);
        }
    },
    created() {
            this.cargaCatalogoSedesArchivo();
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/Catalogos/012SedesArchivo.vue